module.exports = __webpack_public_path__ + "static/media/Beautimap-logo.28565d52.svg";